import { useDraftContext } from "./DraftContext";
import { activeDraftIds, cardState, type DraftCardState, type DraftView, type SavedDraft } from "./draftModel";
import { GenericDraftCard } from "./GenericDraftCard";
import { DRAFT_CARDS } from "./registry";

const isSaved = (d: DraftView | SavedDraft): d is SavedDraft => "at" in d;

/** The cards for one reply's drafts: saved ones (from the conversation), or `live` ones while it streams. */
export function DraftCards({
  drafts,
  live = false,
}: Readonly<{ drafts: readonly (DraftView | SavedDraft)[]; live?: boolean }>) {
  const { saved, linked, streaming } = useDraftContext();
  if (drafts.length === 0) return null;
  const active = activeDraftIds(saved, live ? drafts : []);
  return (
    <div className="space-y-3">
      {drafts.map((d) => {
        const Card = DRAFT_CARDS[d.entityType] ?? GenericDraftCard;
        const { state, entityUuid }: { state: DraftCardState; entityUuid?: string } = isSaved(d)
          ? cardState(d, saved, linked, active)
          : { state: active.has(d.draftId) ? "active" : "superseded" };
        const entity = entityUuid ? linked.find((e) => e.uuid === entityUuid) : undefined;
        return (
          <Card
            key={d.draftId}
            draft={d}
            state={state}
            entityUuid={entityUuid}
            updatedAt={isSaved(d) && d.applied ? d.applied.at : entity?.updatedAt}
            answerable={!streaming && isSaved(d) && !d.answered}
          />
        );
      })}
    </div>
  );
}
